<template>
  <div class="c-conetntsNumber">
    <c-input-v2
      :name="requestItem.name"
      :required="requestItem.requiredFlag"
      :placeholder="requestItem.optionJson.placeholder"
      :max-input-length="MAX_INPUT_LENGTH"
      :show-error-message="false"
      pattern="number"
      v-model="inputValue"
      @input="changeInput"
      @validate="validateInput"
    />
    <span class="c-conetntsNumber_unit">
      {{ requestItem.optionJson.unit }}
    </span>
    <span
      class="c-conetntsNumber_description"
      v-if="requestItem.optionJson.description && descriptionText && inputValue"
    >
      {{ descriptionText }}
    </span>
  </div>
</template>
<script>
const MAX_INPUT_LENGTH = 7

export default {
  name: 'ConetntsNumber',
  props: {
    requestItem: {
      type: Object,
      required: true
    },
    descriptionText: {
      type: String
    }
  },
  data() {
    return {
      MAX_INPUT_LENGTH,
      inputValue: null,
      isValid: false
    }
  },
  methods: {
    changeInput() {
      this.$emit('change', {
        name: this.requestItem.name,
        value: this.inputValue,
        isValid: this.isValid
      })
    },
    validateInput(isValid) {
      this.isValid = isValid
    }
  }
}
</script>
<style lang="scss" scoped>
.c-conetntsNumber {
  display: flex;

  align-items: center;

  /deep/ input {
    padding-left: 12px;
    width: 100px;
    font-size: 14px;
  }
}

@media (max-width: breakpoint(Requests, M)) {
  .c-conetntsNumber {
    font-size: 14px;

    /deep/ input {
      height: 40px;
    }

    &_unit {
      margin-left: 4px;
    }

    &_description {
      margin-left: 12px;
    }
  }
}

@media (min-width: breakpoint(Requests, M) + 1) {
  .c-conetntsNumber {
    font-size: 16px;

    /deep/ input {
      height: 48px;
    }

    &_unit {
      margin-left: 8px;
    }

    &_description {
      margin-left: 24px;
    }
  }
}
</style>
